import {Tooltip} from "@/components/Common/Tooltip";
import {useIsAdmin} from "@/hooks/useUserHooks";
import useUserStore from "@/store/user";
import {isActiveAdminAssignedTrial} from "@/utils/planUtils";
import {useNavigate} from "@tanstack/react-router";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const EmptySocialLink: FC<{socialPlatform: "instagram" | "tiktok"}> = ({socialPlatform}) => {
  const {t} = useTranslation("common");
  const navigate = useNavigate();
  const isAdmin = useIsAdmin();
  const subscription = useUserStore(state => state.user.package_subscription);

  let tooltipTranslationKey = "";
  if (!subscription) {
    tooltipTranslationKey = "purchase_plan_to_see";
  } else if (isActiveAdminAssignedTrial(subscription)) {
    tooltipTranslationKey = "contact_sales_to_see";
  } else if (subscription.status === "trialing") {
    tooltipTranslationKey = "start_your_first_campaign";
  } else if (
    (socialPlatform === "instagram" && subscription.package_category === "TIKTOK") ||
    (socialPlatform === "tiktok" && subscription.package_category === "INSTAGRAM")
  ) {
    tooltipTranslationKey = "upgrade_to_see";
  }

  if (isAdmin || !tooltipTranslationKey) {
    return <span className="text-neutral-black">--</span>;
  }

  return (
    <>
      <button
        data-tooltip-id="blurred-social-link"
        onClick={e => {
          e.stopPropagation();
          navigate({to: subscription?.status === "trialing" ? "/" : "/plans"});
        }}
        className="border-neutral-grey-lightest text-2xs h-3 rounded-sm border bg-linear-(--blur-button-gradient) px-8"
      />
      <Tooltip className="z-1" id="blurred-social-link" variant="dark" place="bottom">
        {t(
          tooltipTranslationKey as
            | "contact_sales_to_see"
            | "purchase_plan_to_see"
            | "start_your_first_campaign"
            | "upgrade_to_see",
        )}
      </Tooltip>
    </>
  );
};

export default EmptySocialLink;
